export default __webpack_public_path__ + "static/proxima-nova-900-2f917de5f058a7cb1daa20936e3ce670.woff2";